import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const TemplateList = lazy(() => import('./TemplateList'));

export const documentRoutes = (
    <React.Fragment key="document">
        <Route path="/document-platform" element={<TemplateList />} />
    </React.Fragment>
);
